const getDefaultState = () => {
    return {
        draftContracts: [],
        singleDraftContract: {
            property: {

            }
        },
        powerSupplyEnabled: false
    }
}


const state = getDefaultState()

const getters = {
    getDraftContracts: (state) => state.draftContracts,
    getSingleDraftContract: (state) => state.singleDraftContract,
    getSingleDraftContractEmail: (state) => {
        return state.singleDraftContract.contractData != undefined
            ? state.singleDraftContract.contractData.tenantEmail
            : '';
    },
    isDraftContractPaid: (state) => {
        return state.singleDraftContract != undefined ? state.singleDraftContract.isPaid : false;
    },
    isDraftContractSent: (state) => {
        return state.singleDraftContract != undefined ? state.singleDraftContract.isSent : false;
    },
    isDraftContractSigned: (state) => {
        return state.singleDraftContract != undefined ? state.singleDraftContract.isSigned : false;
    },
    isPowerSupplyEnabled: (state) => {
        return state.powerSupplyEnabled === true
    }
};

const mutations = {
    resetDraftContractsState: (state) => Object.assign(state, getDefaultState()),
    setDraftContracts: (state, draftContracts) => state.draftContracts = draftContracts,
    setSingleDraftContract: (state, singleDraftContract) => {
        state.singleDraftContract = singleDraftContract;
    },
    setPowerSupplyEnabled: (state, value) => {state.powerSupplyEnabled = value}
};

const actions = {
    async deleteContract({commit, getters, dispatch}, id, callback) {
        await axios({
            method: 'DELETE',
            url: window.config.apiUrl + 'api/draft-contract/' + id,
            cancelToken: window.AuthorizationCancelSource.token,
        }).then(response => {
            dispatch('fetchDraftContracts');
            if (typeof callback == 'function') {
                callback();
            }
        });
    },
    async fetchDraftContracts({commit, getters}, forceApiCall = false) {
        await axios({
            method: 'GET',
            url: window.config.apiUrl + 'api/draft-contract',
            cancelToken: window.AuthorizationCancelSource.token,
        }).then(response => {
            commit('setDraftContracts', response.data);
        });
    },
    resetSingleDraftContract({commit}) {
        commit('setSingleDraftContract', {});
        commit('setLandlordData', {});
        commit('setTenantList', []);
        commit('setTenant', {});
        commit('setTenantId', false);
        commit('setPowerSupplyEnabled', false);
    },
    async fetchSingleDraftContract({commit, getters}, options){
        var draftId = options.id;
        var callback = options.callback;

        if (typeof callback == 'undefined') {
            callback = function() {};
        }

        if(draftId == null){
            commit('setSingleDraftContract', null)
        }
        else{
            await axios({
                method: 'GET',
                cancelToken: window.AuthorizationCancelSource.token,
                url: window.config.apiUrl + 'api/draft-contract/' + draftId,
            }).then(response => {
                if (response.data.contractData.numberOfRooms == undefined || !response.data.contractData.numberOfRooms) {
                    response.data.contractData.numberOfRooms = 1;
                }
                commit('setSingleDraftContract', response.data);
                commit('setLandlordData', response.data.contractData.landlordData);
                commit('setTenantList', response.data.tenants);
                if (response.data.contractData.tenant !== undefined) {
                    commit('setTenant', response.data.contractData.tenant);
                    commit('setTenantId', response.data.contractData.tenant.id);
                } else {
                    commit('setTenant', {});
                    commit('setTenantId', false);
                }
                callback(response.data);
            });
        }
    },
    resetDraftContractsStates: ({commit}) => {
        commit('setDraftContracts', []);
        commit('setSingleDraftContract', '');
        commit('setPowerSupplyEnabled', false);
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
